module.exports = __webpack_public_path__ + "static/media/9-6.2da8260e.mp3";